export const ingCreditRequestValues = {
	reasonCredit: "",
}